/**
 * Javascript file for the navigation.
 * @author Adrian Rebmann, Steffen Schuhmann, Yannik Sprengart
 */

import auth from "../../../auth";
import { postFeedback, getEventRecommendationsBasedOnLocation } from "../../../api";
export default {
  name: "Navigation",

  /**
   * The vue instance's data object.
   * @property {boolean} loggedIn - Status of the user's login.
   * @property {boolean} trainer - Ai trainer status of the user.
   * @property {boolean} writeFeedback - Provide feedback.
   * @property {string} thumb - Thumb for the feedback.
   * @property {string} textarea - Text area for the feedback.
   * @property {string} activeView - Currently active view's name.
   * @property {number} eventrecs - Resulting recommended events.
   */
  data() {
    return {
      loggedIn: auth.loggedIn(),
      trainer: auth.isTrainer(),
      writeFeedback: false,
      thumb: "",
      textarea: "",
      activeView: "",
      eventrecs: 0
    };
  },

  /**
   * Called after the instance is created.
   */
  created() {
    auth.onChange = loggedIn => {
      this.loggedIn = loggedIn;
    };
  },

  /**
   * Called after the instance is mounted.
   */
  mounted() {
    this.setViewText();
  },

  /**
   * Expressions to watch.
   */
  watch: {
    // call the method again if the route changes.
    $route: "setViewText",
    loggedIn: function (val) {
      this.trainer = auth.isTrainer()
      if (val) {
        if (this.loggedIn) {
          getEventRecommendationsBasedOnLocation()
            .then(res => {
              this.eventrecs = res.length
            }).catch(err => {
              console.log(err)
            })
        }
      }
    }
  },

  /**
   * The vue instance's method declaration.
   */
  methods: {
    /**
     * Sets the view name. 
     */
    setViewText() {
      this.activeView = this.$route.meta.viewName;
    },

    /**
     * Sends the feedback provided by the user.
     */
    sendFeedback() {
      postFeedback({
        name: this.thumb,
        description: this.textarea,
        path: this.$route.fullPath
      })
        .then(data => {
          this.textarea = "";
          this.thumb = "";
          this.writeFeedback = false;
        })
        .catch(err => {
          console.error(err);
        })
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/app/navigation/navigation.js